(() => {
  const selector = 'a[href*="boandtee.zendesk.com"]';

  const fix = () => {
    const link = document.querySelector(selector);
    if (!link) return null;
    link.removeAttribute('target');
    link.removeAttribute('rel');
    return link;
  };

  const init = () => {
    const link = fix();
    if (!link) return;
    new MutationObserver(fix).observe(link, {
      attributes: true,
      attributeFilter: ['target', 'rel'],
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();